import { render, staticRenderFns } from "./CreateIkasChannel.vue?vue&type=template&id=2486e31f&scoped=true"
import script from "./CreateIkasChannel.vue?vue&type=script&lang=js"
export * from "./CreateIkasChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateIkasChannel.vue?vue&type=style&index=0&id=2486e31f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486e31f",
  null
  
)

export default component.exports